// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"d22f57ec","856":"80ddec5b","860":"6086b83b"}[chunkId] + ".js";
};